import React from 'react';
import RunningGuy from './RunningGuy';

class HealthPermissionsExplanation extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className={'container'}>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center'}}>
                    <div style={{maxWidth:'90%', margin:'0 5%'}}>
                            <br /><RunningGuy />
                    </div>
                    <div style={{padding:'0 25px 0 25px'}}  className={'grey-font'}>
                    <div>
                        <span className={'activity-tracker-permissions-header'}>Track your steps and earn digital badges!</span>
                    </div>
                    <div style={{textAlign:'left'}}>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-description'}>To activate the Step Counter you must enable health kit permissions on your mobile or wearable device.</span>
                        </div>
                        <div style={{paddingTop:10, paddingBottom:10}}>
                            <span className={'activity-tracker-permissions-description'}>Tap the button below to activate permissions and we'll take it from there!</span>
                        </div>
                    </div>
                    <br />
                        {this.props.button}
                    </div>
                    <br />
                    <div style={{padding:'0 35px 0 35px'}}>
                        <span className={'activity-tracker-permissions-subdescription'}>Dont worry - you can turn the Step Counter off at any time!</span>
                    </div>

                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default HealthPermissionsExplanation;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/HealthPermissionsExplanation.js